// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";
// import privateApi from "../../apis/privateApi";
// import Notification from "../../components/Notification/Notification";
// import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

// import "./BudgetLineEdit.css";

// const BudgetLineEdit = () => {

//     const navigate = useNavigate();
//     const location = useLocation();

//     const budgetLine = location?.state?.budgetLine;

//     // form values
//     const [administrativeUnitId, setAdministrativeUnitId] = useState("");
//     const [programmeId, setProgrammeId] = useState("");
//     const [economicSegmentId, setEconomicSegmentId] = useState("");
//     const [functionalSegmentId, setFunctionalSegmentId] = useState("");
//     const [fundId, setFundId] = useState("");
//     const [amount, setAmount] = useState("");

//     // raw data
//     const [administrativeUnits, setAdministrativeUnits] = useState([]);
//     const [programmes, setProgrammes] = useState([]);
//     const [economicSegments, setEconomicSegments] = useState([]);
//     const [functionalSegments, setFunctionalSegments] = useState([]);
//     const [funds, setFunds] = useState([]);

//     // options
//     const [administrativeUnitOptions, setAdministrativeUnitOptions] = useState([]);
//     const [programmeOptions, setProgrammeOptions] = useState([]);
//     const [economicSegmentOptions, setEconomicSegmentOptions] = useState([]);
//     const [functionalSegmentOptions, setFunctionalSegmentOptions] = useState([]);
//     const [fundOptions, setFundOptions] = useState([]);

//     // UI state
//     const [loading, setLoading] = useState(false);

//     const [notification, setNotification] = useState({
//         show: false,
//         message: "",
//         type: "info"
//     });

//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [confirmToken, setConfirmToken] = useState("");

//     const handleNotificationClose = () =>
//         setNotification(prev => ({ ...prev, show: false }));

//     const generateToken = () =>
//         Math.random().toString(36).substring(2, 8).toUpperCase();


//     // -------------------------
//     // Fetch dropdown data
//     // -------------------------
//     useEffect(() => {

//         const fetchData = async () => {

//             try {

//                 const [
//                     unitsRes,
//                     programmesRes,
//                     economicRes,
//                     functionalRes,
//                     fundRes
//                 ] = await Promise.all([
//                     privateApi.get(`/api/get-create-budget-line-administrative-units?level=${budgetLine.level}`),
//                     privateApi.get(`/api/get-create-budget-line-programmes?level=${budgetLine.level}`),
//                     privateApi.get(`/api/get-create-budget-line-economic-segments?level=${budgetLine.level}`),
//                     privateApi.get(`/api/get-create-budget-line-functional-segments?level=${budgetLine.level}`),
//                     privateApi.get(`/api/get-create-budget-line-funds?level=${budgetLine.level}`),
//                 ]);

//                 setAdministrativeUnits(unitsRes.data.data || []);
//                 setProgrammes(programmesRes.data.data || []);
//                 setEconomicSegments(economicRes.data.data || []);
//                 setFunctionalSegments(functionalRes.data.data || []);
//                 setFunds(fundRes.data.data || []);

//             } catch {

//                 setNotification({
//                     show: true,
//                     message: "Failed to load form data.",
//                     type: "error"
//                 });

//             }

//         };

//         if (budgetLine) fetchData();

//     }, [budgetLine]);


//     // -------------------------
//     // Pre-fill values
//     // -------------------------
//     useEffect(() => {

//         if (!budgetLine) return;

//         setAdministrativeUnitId(budgetLine?.administrativeUnitId?._id || "");
//         setProgrammeId(budgetLine?.programmeId?._id || "");
//         setEconomicSegmentId(budgetLine?.economicSegmentId?._id || "");
//         setFunctionalSegmentId(budgetLine?.functionalSegmentId?._id || "");
//         setFundId(budgetLine?.fundId?._id || "");
//         setAmount(budgetLine?.amount || "");

//     }, [budgetLine]);

//     // -------------------------
//     // Build options
//     // -------------------------
//     useEffect(() => {
//         const flattenSegments = (segments, depth = 0) => {

//             let result = [];

//             segments.forEach(seg => {

//                 result.push({ ...seg, depth });

//                 if (seg.children && seg.children.length > 0) {
//                     result = result.concat(flattenSegments(seg.children, depth + 1));
//                 }

//             });

//             return result;
//         };
//         const flat = flattenSegments(programmes);

//         const options = flat.map(seg => ({
//             value: seg._id,
//             label: `${"▶".repeat(seg.depth)} ${seg.code} - ${seg.name}`
//         }));

//         setProgrammeOptions(options);

//     }, [programmes]);


//     useEffect(() => {
//         const flattenSegments = (segments, depth = 0) => {

//             let result = [];

//             segments.forEach(seg => {

//                 result.push({ ...seg, depth });

//                 if (seg.children && seg.children.length > 0) {
//                     result = result.concat(flattenSegments(seg.children, depth + 1));
//                 }

//             });

//             return result;
//         };

//         const flat = flattenSegments(administrativeUnits);

//         const options = flat.map(seg => ({
//             value: seg._id,
//             label: `${"▶".repeat(seg.depth)} ${seg.code} - ${seg.descriptionFederal ||
//                 seg.descriptionState ||
//                 seg.descriptionLocal}`
//         }));

//         setAdministrativeUnitOptions(options);

//     }, [administrativeUnits]);


//     useEffect(() => {
//         const flattenSegments = (segments, depth = 0) => {

//             let result = [];

//             segments.forEach(seg => {

//                 result.push({ ...seg, depth });

//                 if (seg.children && seg.children.length > 0) {
//                     result = result.concat(flattenSegments(seg.children, depth + 1));
//                 }

//             });

//             return result;
//         };
//         const flat = flattenSegments(economicSegments);

//         const options = flat.map(seg => ({
//             value: seg._id,
//             label: `${"▶".repeat(seg.depth)} ${seg.code} - ${seg.descriptionFederal ||
//                 seg.descriptionState ||
//                 seg.descriptionLocal}`
//         }));

//         setEconomicSegmentOptions(options);

//     }, [economicSegments]);

//     useEffect(() => {
//         const flattenSegments = (segments, depth = 0) => {

//             let result = [];

//             segments.forEach(seg => {

//                 result.push({ ...seg, depth });

//                 if (seg.children && seg.children.length > 0) {
//                     result = result.concat(flattenSegments(seg.children, depth + 1));
//                 }

//             });

//             return result;
//         };
//         const flat = flattenSegments(functionalSegments);

//         const options = flat.map(seg => ({
//             value: seg._id,
//             label: `${"▶".repeat(seg.depth)} ${seg.code} - ${seg.descriptionFederal ||
//                 seg.descriptionState ||
//                 seg.descriptionLocal}`
//         }));

//         setFunctionalSegmentOptions(options);

//     }, [functionalSegments]);


//     useEffect(() => {
//         const flattenSegments = (segments, depth = 0) => {

//             let result = [];

//             segments.forEach(seg => {

//                 result.push({ ...seg, depth });

//                 if (seg.children && seg.children.length > 0) {
//                     result = result.concat(flattenSegments(seg.children, depth + 1));
//                 }

//             });

//             return result;
//         };
//         const flat = flattenSegments(funds);

//         const options = flat.map(seg => ({
//             value: seg._id,
//             label: `${"▶".repeat(seg.depth)} ${seg.code} - ${seg.descriptionFederal ||
//                 seg.descriptionState ||
//                 seg.descriptionLocal}`
//         }));

//         setFundOptions(options);

//     }, [funds]);


//     // -------------------------
//     // Submit
//     // -------------------------
//     const handleSubmit = e => {

//         e.preventDefault();

//         const token = generateToken();

//         setConfirmToken(token);

//         setConfirmOpen(true);
//     };


//     const handleConfirm = async input => {

//         if (input !== confirmToken) {

//             setNotification({
//                 show: true,
//                 message: "Incorrect confirmation code.",
//                 type: "error"
//             });

//             setConfirmOpen(false);
//             return;
//         }

//         setConfirmOpen(false);
//         setLoading(true);

//         try {

//             const data = {
//                 administrativeUnitId,
//                 programmeId,
//                 economicSegmentId,
//                 functionalSegmentId,
//                 fundId,
//                 amount: Number(amount)
//             };

//             await privateApi.patch(`/api/budget-lines/${budgetLine._id}`, data);

//             setNotification({
//                 show: true,
//                 message: "Budget line updated successfully.",
//                 type: "success"
//             });

//         } catch (err) {

//             setNotification({
//                 show: true,
//                 message:
//                     err.response?.data?.message ||
//                     "Failed to update budget line.",
//                 type: "error"
//             });

//         } finally {
//             setLoading(false);
//         }

//     };


//     const handleCancel = () => setConfirmOpen(false);


//     if (!budgetLine)
//         return <p>No budget line selected.</p>;


//     return (

//         <div className="budgetline-edit">

//             <h2>Edit Budget Line</h2>

//             <Notification
//                 show={notification.show}
//                 message={notification.message}
//                 type={notification.type}
//                 onClose={handleNotificationClose}
//             />

//             <form onSubmit={handleSubmit}>

//                 <div className="budgetline-edit-form-group">
//                     <label>Administrative Unit</label>
//                     <Select
//                         options={administrativeUnitOptions}
//                         value={administrativeUnitOptions.find(o => o.value === administrativeUnitId) || null}
//                         onChange={opt => setAdministrativeUnitId(opt?.value || "")}
//                         isSearchable
//                         isClearable
//                     />
//                 </div>


//                 <div className="budgetline-edit-form-group">
//                     <label>Programme</label>
//                     <Select
//                         options={programmeOptions}
//                         value={programmeOptions.find(o => o.value === programmeId) || null}
//                         onChange={opt => setProgrammeId(opt?.value || "")}
//                         isSearchable
//                         isClearable
//                     />
//                 </div>


//                 <div className="budgetline-edit-form-group">
//                     <label>Economic Segment</label>
//                     <Select
//                         options={economicSegmentOptions}
//                         value={economicSegmentOptions.find(o => o.value === economicSegmentId) || null}
//                         onChange={opt => setEconomicSegmentId(opt?.value || "")}
//                         isSearchable
//                         isClearable
//                     />
//                 </div>

//                 <div className="budgetline-edit-form-group">
//                     <label>Functional Segment</label>
//                     <Select
//                         options={functionalSegmentOptions}
//                         value={functionalSegmentOptions.find(o => o.value === functionalSegmentId) || null}
//                         onChange={opt => setFunctionalSegmentId(opt?.value || "")}
//                         isSearchable
//                         isClearable
//                     />
//                 </div>


//                 <div className="budgetline-edit-form-group">
//                     <label>Fund</label>
//                     <Select
//                         options={fundOptions}
//                         value={fundOptions.find(o => o.value === fundId) || null}
//                         onChange={opt => setFundId(opt?.value || "")}
//                         isSearchable
//                         isClearable
//                     />
//                 </div>


//                 <div className="budgetline-edit-form-group">
//                     <label>Amount</label>
//                     <input
//                         type="number"
//                         value={amount}
//                         onChange={e => setAmount(e.target.value)}
//                         required
//                     />
//                 </div>


//                 <div className="budgetline-edit-action-buttons">

//                     <button
//                         type="submit"
//                         className="budgetline-edit-btn"
//                         disabled={loading}
//                     >
//                         {loading ? "Updating..." : "Update Budget Line"}
//                     </button>

//                     <button
//                         type="button"
//                         className="budgetline-edit-back-btn"
//                         onClick={() => navigate(-1)}
//                     >
//                         Back
//                     </button>

//                 </div>

//             </form>

//             <ConfirmDialog
//                 show={confirmOpen}
//                 token={confirmToken}
//                 action="You are about to update this budget line"
//                 onConfirm={handleConfirm}
//                 onCancel={handleCancel}
//             />

//         </div>
//     );
// };

// export default BudgetLineEdit;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import privateApi from "../../apis/privateApi";
import Notification from "../../components/Notification/Notification";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import "./BudgetLineEdit.css";

/* ─── react-select styles ────────────────────────────────────── */
const rsStyles = {
    control: (b, s) => ({
        ...b,
        borderColor: s.isFocused ? "#006B3C" : "#D2DDD5",
        boxShadow: s.isFocused ? "0 0 0 3px rgba(0,107,60,.18)" : "none",
        "&:hover": { borderColor: "#006B3C" },
        borderRadius: 6, fontSize: 13, minHeight: 38,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background: "#F0F4F1",
        transition: "border-color .18s, box-shadow .18s",
    }),
    option: (b, s) => ({
        ...b, fontSize: 13,
        background: s.isSelected ? "#006B3C" : s.isFocused ? "rgba(0,107,60,.07)" : "#fff",
        color: s.isSelected ? "#fff" : "#0E1F14",
    }),
    menu: (b) => ({ ...b, zIndex: 9999, borderRadius: 10, border: "1px solid #D2DDD5", boxShadow: "0 12px 40px rgba(1,45,26,.16)" }),
    menuPortal: (b) => ({ ...b, zIndex: 9999 }),
    placeholder: (b) => ({ ...b, color: "#9BB0A0", fontSize: 13 }),
    singleValue: (b) => ({ ...b, color: "#0E1F14" }),
};

/* ─── Flatten tree ───────────────────────────────────────────── */
const flatten = (items, depth = 0) => {
    let out = [];
    items.forEach(item => {
        out.push({ ...item, depth });
        if (item.children?.length) out = out.concat(flatten(item.children, depth + 1));
    });
    return out;
};

const buildOpts = (items, labelFn) =>
    flatten(items).map(seg => ({
        value: seg._id,
        label: `${"  ".repeat(seg.depth)}${seg.code ? `${seg.code} — ` : ""}${labelFn(seg)}`,
    }));

const descFn = seg =>
    seg.description || seg.descriptionState || seg.descriptionFederal || seg.descriptionLocal || seg.name || "";

const BudgetLineEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const budgetLine = location?.state?.budgetLine;

    const [administrativeUnitId, setAdministrativeUnitId] = useState("");
    const [programmeId, setProgrammeId] = useState("");
    const [economicSegmentId, setEconomicSegmentId] = useState("");
    const [functionalSegmentId, setFunctionalSegmentId] = useState("");
    const [fundId, setFundId] = useState("");
    const [amount, setAmount] = useState("");

    const [administrativeUnits, setAdministrativeUnits] = useState([]);
    const [programmes, setProgrammes] = useState([]);
    const [economicSegments, setEconomicSegments] = useState([]);
    const [functionalSegments, setFunctionalSegments] = useState([]);
    const [funds, setFunds] = useState([]);

    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmToken, setConfirmToken] = useState("");

    /* Fetch segment data */
    useEffect(() => {
        if (!budgetLine) return;
        (async () => {
            try {
                const [u, p, e, f, fn] = await Promise.all([
                    privateApi.get(`/api/get-create-budget-line-administrative-units?level=${budgetLine.budgetLevel}`),
                    privateApi.get(`/api/get-create-budget-line-programmes?level=${budgetLine.budgetLevel}`),
                    privateApi.get(`/api/get-create-budget-line-economic-segments?level=${budgetLine.budgetLevel}`),
                    privateApi.get(`/api/get-create-budget-line-functional-segments?level=${budgetLine.budgetLevel}`),
                    privateApi.get(`/api/get-create-budget-line-funds?level=${budgetLine.budgetLevel}`),
                ]);
                setAdministrativeUnits(u.data.data || []);
                setProgrammes(p.data.data || []);
                setEconomicSegments(e.data.data || []);
                setFunctionalSegments(f.data.data || []);
                setFunds(fn.data.data || []);
            } catch {
                setNotification({ show: true, message: "Failed to load form data.", type: "error" });
            }
        })();
    }, [budgetLine]);

    /* Pre-fill */
    useEffect(() => {
        if (!budgetLine) return;
        setAdministrativeUnitId(budgetLine.administrativeUnitId?._id || "");
        setProgrammeId(budgetLine.programmeId?._id || "");
        setEconomicSegmentId(budgetLine.economicSegmentId?._id || "");
        setFunctionalSegmentId(budgetLine.functionalSegmentId?._id || "");
        setFundId(budgetLine.fundId?._id || "");
        setAmount(budgetLine.amount || "");
    }, [budgetLine]);

    /* Build options */
    const adminOpts = buildOpts(administrativeUnits, descFn);
    const progOpts = buildOpts(programmes, s => s.name || "");
    const econOpts = buildOpts(economicSegments, descFn);
    const funcOpts = buildOpts(functionalSegments, descFn);
    const fundOpts = buildOpts(funds, descFn);

    const fmtAmt = v => (!v ? "" : v.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));

    const handleSubmit = e => {
        e.preventDefault();
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        setConfirmToken(token);
        setConfirmOpen(true);
    };

    const handleConfirm = async input => {
        if (input !== confirmToken) {
            setNotification({ show: true, message: "Incorrect confirmation code.", type: "error" });
            setConfirmOpen(false);
            return;
        }
        setConfirmOpen(false);
        setLoading(true);
        try {
            await privateApi.patch(`/api/budget-lines/${budgetLine._id}`, {
                administrativeUnitId, programmeId, economicSegmentId,
                functionalSegmentId, fundId, amount: Number(amount),
            });
            setNotification({ show: true, message: "Budget line updated successfully.", type: "success" });
            setTimeout(() => {
                navigate(-1);
            }, 2000);
        } catch (err) {
            setNotification({ show: true, message: err.response?.data?.message || "Failed to update budget line.", type: "error" });
        } finally { setLoading(false); }
    };

    if (!budgetLine) return (
        <div className="bgt-page-centered">
            <p style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>No budget line selected.</p>
        </div>
    );

    /* Shared Select wrapper */
    const RS = ({ label, options, value, onChange }) => (
        <div className="bgt-form-group">
            <label className="bgt-label">{label}</label>
            <div className="bgt-rs-wrap">
                <Select styles={rsStyles} menuPortalTarget={document.body} menuPosition="fixed"
                    options={options} isSearchable isClearable
                    value={options.find(o => o.value === value) || null}
                    onChange={opt => onChange(opt?.value || "")} />
            </div>
        </div>
    );

    return (
        <div className="bgt-page-centered">
            <div className="ble-inner">
                <Notification show={notification.show} message={notification.message}
                    type={notification.type} onClose={() => setNotification(p => ({ ...p, show: false }))} />

                <div className="bgt-card" style={{ animation: "bgt-fadeUp .45s ease both" }}>
                    <div className="bgt-card-header">
                        <h2>Edit Budget Line</h2>
                        <p>Modify segment assignments and budgeted amount</p>
                    </div>

                    <form className="bgt-form-body" onSubmit={handleSubmit}>
                        <div className="bgt-section-title">Segments</div>
                        <div className="ble-two-col">
                            <RS label="Administrative Unit" options={adminOpts} value={administrativeUnitId} onChange={setAdministrativeUnitId} />
                            <RS label="Economic Segment" options={econOpts} value={economicSegmentId} onChange={setEconomicSegmentId} />
                            <RS label="Functional Segment" options={funcOpts} value={functionalSegmentId} onChange={setFunctionalSegmentId} />
                            <RS label="Fund" options={fundOpts} value={fundId} onChange={setFundId} />
                            <div className="ble-full-col">
                                <RS label="Programme" options={progOpts} value={programmeId} onChange={setProgrammeId} />
                            </div>
                        </div>

                        <div className="bgt-form-divider" />
                        <div className="bgt-section-title">Amount</div>

                        <div className="bgt-form-group">
                            <label className="bgt-label required">Budgeted Amount</label>
                            <div className="bgt-amount-wrap">
                                <span className="bgt-amount-prefix">₦</span>
                                <input className="bgt-input bgt-amount-input" type="text" required
                                    value={fmtAmt(amount)}
                                    onChange={e => {
                                        const raw = e.target.value.replace(/,/g, "");
                                        if (!/^\d*$/.test(raw)) return;
                                        setAmount(raw);
                                    }}
                                    placeholder="0" />
                            </div>
                        </div>

                        <div className="bgt-form-actions">
                            <button type="button" className="bgt-btn bgt-btn-secondary" onClick={() => navigate(-1)}>← Back</button>
                            {budgetLine.budgetSatus === 'draft' &&
                                <button type="submit" className="bgt-btn bgt-btn-primary" disabled={loading}>
                                    {loading ? "Updating…" : "✓ Update Budget Line"}
                                </button>
                            }
                        </div>
                    </form>
                </div>
            </div>

            <ConfirmDialog show={confirmOpen} token={confirmToken}
                action="You are about to update this budget line"
                onConfirm={handleConfirm} onCancel={() => setConfirmOpen(false)} />
        </div>
    );
};

export default BudgetLineEdit;